import Vue from 'vue'
export const EventBus = new Vue()
import { ToastPlugin, ModalPlugin } from 'bootstrap-vue'
import VueCompositionAPI from '@vue/composition-api'
import {getCorrectDateTime, maxDate, getDateTime} from '@/libs/helper'
Vue.prototype.getCorrectDateTime = getCorrectDateTime
Vue.prototype.getDateTime = getDateTime
Vue.prototype.maxDate = maxDate

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import {
  faArrowsRotate,
  faArrowLeft,
  faBell,
  faBuildingColumns,
  faCalculator,
  faCalendar,
  faCartShopping,
  faChartSimple,
  faCircleCheck,
  faCircleInfo,
  faCircleXmark,
  faClock,
  faClockRotateLeft,
  faCloudArrowUp,
  faComments,
  faCreditCard,
  faDiamondTurnRight,
  faEnvelope,
  faFile,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines,
  faFolder,
  faGear,
  faHandHoldingDollar,
  faIdCard,
  faInfo,
  faLaptopHouse,
  faListCheck,
  faLocationDot,
  faMessage,
  faMoneyCheckDollar,
  faPen,
  faPenToSquare,
  faPeopleCarryBox,
  faPerson,
  faPersonDigging,
  faPersonRunning,
  faPhone,
  faPlus,
  faReceipt,
  faRightFromBracket,
  faStar,
  faTableCellsLarge,
  faTicket,
  faTimeline,
  faTimes,
  faTrash,
  faTruckField,
  faUser,
  faUserClock,
  faUsers,
  faUserTie,
} from '@fortawesome/free-solid-svg-icons'

library.add( 
  faArrowsRotate,
  faArrowLeft,
  faBell,
  faBuildingColumns,
  faCalculator,
  faCalendar,
  faCartShopping,
  faChartSimple,
  faCircleCheck,
  faCircleInfo,
  faCircleXmark,
  faClock,
  faClockRotateLeft,
  faCloudArrowUp,
  faComments,
  faCreditCard,
  faDiamondTurnRight,
  faEnvelope,
  faFile,
  faFileInvoice,
  faFileInvoiceDollar,
  faFileLines,
  faFolder,
  faGear,
  faHandHoldingDollar,
  faIdCard,
  faInfo,
  faLaptopHouse,
  faListCheck,
  faLocationDot,
  faMessage,
  faMoneyCheckDollar,
  faPen,
  faPenToSquare,
  faPeopleCarryBox,
  faPerson,
  faPersonDigging,
  faPersonRunning,
  faPhone,
  faPlus,
  faReceipt,
  faRightFromBracket,
  faStar,
  faTableCellsLarge,
  faTicket,
  faTimeline,
  faTimes,
  faTrash,
  faTruckField,
  faUser,
  faUserClock,
  faUsers,
  faUserTie,
)
Vue.component('font-awesome-icon', FontAwesomeIcon)

import VueApexCharts from 'vue-apexcharts'
Vue.use(VueApexCharts)

Vue.component('apexchart', VueApexCharts)

import router from './router'
import store from './store'
import App from './App.vue'

// Global Components
import './global-components'

// 3rd party plugins
import '@/libs/portal-vue'
import '@/libs/toastification'
import '@/libs/acl'
import '@/libs/sweet-alerts'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css';
import locale from 'element-ui/lib/locale/lang/en'

// BSV Plugin Registration
Vue.use(ToastPlugin)
Vue.use(ModalPlugin)
Vue.use(ElementUI, {locale})

// Composition API
Vue.use(VueCompositionAPI)

// import core styles
require('@core/scss/core.scss')

// import assets styles
require('@/assets/scss/style.scss')

Vue.config.productionTip = false

// 在開發環境中引入權限測試工具
if (process.env.NODE_ENV === 'development') {
  import('./test-permission-check.js').then(() => {
    console.log('🧪 權限測試工具已載入')
  }).catch(error => {
    console.warn('⚠️ 權限測試工具載入失敗:', error)
  })
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
